// removed by extract-text-webpack-plugin
module.exports = {"easy-need-offer":"easy-need-offer","easy-need-offer-left-content":"easy-need-offer-left-content","product-image":"product-image","name-link":"name-link","description":"description","time":"time"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/easy-need-offer/style.scss
// module id = ./components/partials/easy-need-offer/style.scss
// module chunks = 0